<template lang="pug">
.flex.gap-0.gap-2
    .flex.self-center.gap-2
        UDropdownMenu(
            :items="items"
            :ui="{content: 'bg-white w-56'}"
        )
            UBadge.rounded-full.flex.py-1.self-center.gap-2(
                :ui="{base: 'text-sm'}"
                class="cursor-pointer"
                color="secondary"
                variant="soft"
                size="xs"
            )
                .flex.self-center
                    UAvatar.rounded-full(
                        size="xs"
                        :src="authData?.avatar || 'https://aimvatar.aimi.workers.dev/X'"
                    )
                .flex.truncate.self-center.pr-2.text-xs.hidden(class="md:block")
                    .line-clamp-1.text-ellipsis.truncate {{ authData?.fullname }}&nbsp;/&nbsp;{{ authData?.role }}

            template(#profile)
                .flex.flex-1.flex-col.text-sm.font-normal.gap-1
                    .flex.font-medium.text-ellipsis.truncate.line-clamp-1
                        | {{ authData?.fullname }}
                    .flex.items-center.gap-2.flex-1(class="md:hidden")
                        .text-xs {{ authData?.email }}
                        UBadge(variant="soft" color="secondary" size="sm") {{ authData?.role }}
</template>

<script setup lang="ts">
const colorMode = useColorMode()
const authData = useState('auth')

const isDark = computed({
    get() {
        return colorMode.value === 'dark'
    },
    set() {
        colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
    },
})

const items = computed(() => [
    [
        {
            label: 'profile',
            type: 'label',
            slot: 'profile',
        },
    ],
    [
        {
            label: 'Profile',
            icon: 'i-lucide-user',
            kbds: ['P'],
            to: '/profile',
        },
        {
            label: 'Settings',
            icon: 'i-lucide-cog',
            kbds: ['S'],
            to: '/settings',
        },
        {
            label: ` ${colorMode.preference === 'light' ? 'Dark' : 'Light'} Mode`,
            icon: colorMode.preference === 'light' ? 'i-lucide-moon' : 'i-lucide-sun',
            onSelect() {
                colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
            },
            onClick: () => {
                colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
            },
            /// kbds: ['shift', 'meta', 'd'],
        },

        // {
        //     label: 'Support',
        //     icon: 'i-lucide-life-buoy',
        //     to: '/components/dropdown-menu',
        // },
    ],
    [
        {
            label: 'Logout',
            icon: 'i-lucide-log-out',
            to: '/logout',
            // kbds: ['shift', 'meta', 'q'],
        },
    ],
])
</script>
